/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getApiProfileCvPreview200Schema = z.any();

export const getApiProfileCvPreviewQueryResponseSchema = z.lazy(
  () => getApiProfileCvPreview200Schema,
);
